module.exports = __webpack_public_path__ + "img/1513928504.f0135829.jpg";